import type { PriceHotBlogItem } from 'api-price'
import useLangPrefix from '@/hooks/useLangPrefix'
import { eventTracker } from '@/utils/collectEvent'
import { useAdapter } from '@/components/Adapter'
import BaseImage from '@/components/BaseImage'
import unkownh5 from '@/public/images/icon-news-unkown-h5.png'
import unkownpc from '@/public/images/icon-news-unkown-pc.png'
import BaseTooltip from '@/components/BaseTooltip'
import { ArticleItemStyled, ArticleItemDescStyled, ArticleItemDescBox, FundraisingNewsItem } from './style'
import { Flex } from '@mantine/core'

const ArticleItem: React.FC<PriceHotBlogItem & { isFundraising?: boolean }> = ({ isFundraising, ...props }) => {
  const { langPrefix } = useLangPrefix()

  const articleHref = `${langPrefix}/${props?.uri}`

  const { isH5 } = useAdapter()

  if (isFundraising) {
    return (
      <FundraisingNewsItem onClick={() => void (props?.uri && window.open(props?.uri))}>
        <BaseImage className="fundraising-bg" src={`/price/public/images/bg-fundraising-news-${props?.imgurl}.png`} />

        <Flex direction="column" gap={8} mt={16}>
          <div style={{ height: '48px' }}>
            <BaseTooltip
              ellipsisLines={2}
              tooltipMaw={248}
              label={props?.author}
              className="text-1 size-16 font-500 line-150"
            >
              {props?.author?.length ? props?.author : '--'}
            </BaseTooltip>
          </div>

          <BaseTooltip tooltipMaw={248} label={props?.title} className="text-3 size-12 font-400 line-120">
            {props?.title?.length ? props?.title : '--'}
          </BaseTooltip>
        </Flex>
      </FundraisingNewsItem>
    )
  }

  return (
    <ArticleItemStyled>
      <a
        onClick={() => {
          eventTracker('price_sectors_click', {
            highlights_url: articleHref,
          })
        }}
        href={articleHref}
        target="_blank"
        className="price-article-item--box"
      >
        <BaseImage
          className="price-article-item--image"
          src={props?.imgurl}
          errorUrl={isH5 ? unkownh5 : unkownpc}
          alt={props.title}
        />
        <ArticleItemDescBox>
          <BaseTooltip
            tooltipMaw={248}
            isToolTipState
            label={props?.title ?? '--'}
            className="text-1 size-16 font-500 line-150"
          >
            <ArticleItemDescStyled>{props?.title ?? '--'}</ArticleItemDescStyled>
          </BaseTooltip>
        </ArticleItemDescBox>
      </a>
    </ArticleItemStyled>
  )
}

export default ArticleItem
